import React, { Component } from "react";
import styles from "./ErrorPage.scss";

export default class ErrorPage extends Component {
  render() {
    return (
      <div className={styles.errorpage}>
        <h1>404</h1>
        <h5>page does not exist</h5>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/ErrorPage/ErrorPage.js